import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "mv-snz-row" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "mv-snz-btns" }
const _hoisted_8 = ["disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileStatusSheet',
  props: {
    open: { type: Boolean },
    snoozeMode: { type: Boolean },
    currentStatus: {},
    statusLoading: { type: Boolean },
    snoozeH: {},
    snoozeM: {}
  },
  emits: ["close", "change-status", "update:snoozeMode", "update:snoozeH", "update:snoozeM", "confirm-snooze"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mv-sheet-overlay",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createElementVNode("div", {
            class: "mv-sheet",
            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
          }, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "mv-sheet-handle" }, null, -1)),
            (!__props.snoozeMode)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mv-sheet-title" }, "Alterar status", -1)),
                  (__props.currentStatus !== 'open')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "mv-sheet-opt",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change-status', 'open'))),
                        disabled: __props.statusLoading
                      }, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("span", { class: "mv-sdot open" }, null, -1),
                        _createTextVNode(" Abrir ", -1)
                      ]))], 8, _hoisted_1))
                    : _createCommentVNode("", true),
                  (__props.currentStatus !== 'resolved')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "mv-sheet-opt",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change-status', 'resolved'))),
                        disabled: __props.statusLoading
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("span", { class: "mv-sdot resolved" }, null, -1),
                        _createTextVNode(" Resolver ", -1)
                      ]))], 8, _hoisted_2))
                    : _createCommentVNode("", true),
                  (__props.currentStatus !== 'pending')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "mv-sheet-opt",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change-status', 'pending'))),
                        disabled: __props.statusLoading
                      }, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("span", { class: "mv-sdot pending" }, null, -1),
                        _createTextVNode(" Pendente ", -1)
                      ]))], 8, _hoisted_3))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "mv-sheet-opt",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:snoozeMode', true)))
                  }, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("span", { class: "mv-sdot snoozed" }, null, -1),
                    _createTextVNode(" Adiar… ", -1)
                  ]))])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "mv-sheet-title" }, "Adiar por quanto tempo?", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("input", {
                      type: "number",
                      value: __props.snoozeH,
                      onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:snoozeH', Number(($event.target as HTMLInputElement).value)))),
                      min: "0",
                      max: "99",
                      class: "mv-snz-inp"
                    }, null, 40, _hoisted_5),
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "mv-snz-lbl" }, "h", -1)),
                    _createElementVNode("input", {
                      type: "number",
                      value: __props.snoozeM,
                      onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:snoozeM', Number(($event.target as HTMLInputElement).value)))),
                      min: "0",
                      max: "59",
                      class: "mv-snz-inp"
                    }, null, 40, _hoisted_6),
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "mv-snz-lbl" }, "min", -1))
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mv-snz-hint" }, "0h 0min = até próxima resposta", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "mv-snz-cancel",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:snoozeMode', false)))
                    }, "Cancelar"),
                    _createElementVNode("button", {
                      class: "mv-snz-confirm",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('confirm-snooze'))),
                      disabled: __props.statusLoading
                    }, "Confirmar", 8, _hoisted_8)
                  ])
                ], 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})